<template>
  
  <div>
  <el-dialog title="添加访问次数" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="广告图片"  :label-width="formLabelWidth">
        <el-image 
            style="width: 200px; height: 100px"
            :src="form.image_url" 
            :preview-src-list="[form.image_url]">
        </el-image>
      </el-form-item>
      <el-form-item label="当前浏览次数"  :label-width="formLabelWidth">
        {{form.view_times}}
      </el-form-item>
      <el-form-item label="增加次数"  :label-width="formLabelWidth">
        <el-input size="small" type="number" min="0" step="1" v-model="form.num" width="50" placeholder="请输入点击次数"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addtUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import StatisticsApi from '@/api/statistics.js';
  export default {
    components: {
    },
    data() {
      return {
        /*是否打开选择商品*/
        isproduct: false,
        open_user: false,
        /*产品去重*/
        excludeIds: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        product:{},
        user:{},
        user_id: '',
        form: {
          user_id: '',
          product_id: '',
          product_number: '',
        },
      };
    },
    props: ['open_add','model'],
    created() {
      this.form=this.model;
      this.dialogVisible = this.open_add;

    },
    methods: {
      /*添加*/
      addtUser() {
        let self = this;

        let params = self.form;
        if(!params.num){
            this.showMessage('请输入次数');
            return ;
        }
        self.loading = true;
        StatisticsApi.viewEdit(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/banner/part/dialog/Add.vue